import script from "./MessageDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageDrawer.vue?vue&type=script&setup=true&lang=js"

import "./MessageDrawer.vue?vue&type=style&index=0&id=506b8e97&lang=less&scoped=true"
import "./MessageDrawer.vue?vue&type=style&index=1&id=506b8e97&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-506b8e97"]])

export default __exports__